import { useQuery } from '@apollo/react-hooks';
import { GET_PUBLICATION } from './GET_PUBLICATION.gql';
import { type PublicationPayloadGql, type PublicationPayload } from './types';
import { checkInvalidDate } from '../checkInvalidDate';

export const getPublication = (id: string): PublicationPayloadGql => {
  const { data, loading, error } = useQuery(GET_PUBLICATION, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const {
    publicationType = '',
    publicationAuthors = '',
    publicationTitle = '',
    publicationName = '',
    applicantRole = '',
    specificRole = '',
    publicationStatus = '',
    publicationDate = null,
    issuePageArticelNo = '',
    peerReviewedIndicator = false,
    citationInfo = '',
    publicationUrl = '',
    supportingDocuments = [],
  } = (data?.publication as PublicationPayload) ?? {};

  const publication: PublicationPayload = {
    publicationType,
    publicationAuthors,
    publicationTitle,
    publicationName,
    applicantRole,
    specificRole,
    publicationStatus,
    publicationDate: checkInvalidDate(publicationDate) ? null : publicationDate,
    issuePageArticelNo,
    peerReviewedIndicator: peerReviewedIndicator ?? false,
    citationInfo,
    publicationUrl,
    supportingDocuments,
  };

  return { publication, loading, error };
};
